export default "__VITE_ASSET__BNoE361I__"